import { ChangeDetectionStrategy, Component, EventEmitter, NgModule, Output } from '@angular/core';
import { FocusToDirectiveModule } from '@commons/directives/focus-to/focus-to.directive';
import { HeroModule } from '@commons/hero/hero.component';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import { environment } from '@environment';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { SharedModule } from '@shared/shared.module';
import { ImaginarySrcModule } from '@wizbii/angular-utilities';
import { trackEventWithAtInternet } from '@wizbii/tracking';
import { ClickType } from '@wizbii/tracking/dist/model';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-youth-info-center-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YouthInfoCenterHeroComponent {
  @Output() scrollToId = new EventEmitter<string>();

  illustration = {
    src: `${environment.wizbiiImages}/accompagnement/hero.png`,
    width: 951,
  };

  trackEvent = trackEventWithAtInternet;

  get isMobileOrTablet$(): Observable<boolean> {
    return this.breakpointsService.isMobileAndTabletPortrait$;
  }

  get isIpadPro$(): Observable<boolean> {
    return this.breakpointsService.isIpadPro$;
  }

  constructor(private readonly breakpointsService: BreakpointsService) {}

  onClickScrollToId(id: string, tracker: { category: string; action: string; type: ClickType; label: string }): void {
    this.trackEvent({ category: tracker.category, action: tracker.action, type: tracker.type, label: tracker.label });
    this.scrollToId.emit(id);
  }
}

@NgModule({
  imports: [SharedModule, ImaginarySrcModule, ScrollToModule, FocusToDirectiveModule, HeroModule],
  declarations: [YouthInfoCenterHeroComponent],
  exports: [YouthInfoCenterHeroComponent],
})
export class YouthInfoCenterHeroModule {}
